<template>
  <v-dialog v-model="dialog" max-width="80%" persistent>
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="text-h6 font-weight-medium">Detalles del Proveedor</span>
        
        <v-chip
          v-if="!loading"
          :color="proveedor.bloqueado ? 'error' : !proveedor.validado ? 'warning' : 'success'"
          dark
          label
          class="px-4"
        >
          <v-icon left small>
            {{ proveedor.bloqueado ? 'mdi-lock-alert' : !proveedor.validado ? 'mdi-file-clock-outline' : 'mdi-check-circle' }}
          </v-icon>
          <span class="font-weight-bold">
            {{ proveedor.bloqueado ? 'BLOQUEADO' : !proveedor.validado ? 'SIN VALIDAR' : 'VALIDADO' }}
          </span>
        </v-chip>
      </v-card-title>


      <v-card-text v-if="loading" class="text-center py-8">
        <v-progress-circular
          indeterminate
          size="128"
          width="4"
          class="mb-3"
          color="primary"
        ></v-progress-circular>
        <div class="text-subtitle-2">
          Cargando detalles del proveedor ...
        </div>
      </v-card-text>

      <v-card-text v-else>
        <v-row class="pa-0 ma-0">
          <!-- Información Básica -->
          <v-col cols="12" class="pa-0 ma-0 text-center">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon>mdi-domain</v-icon>
              Información Básica
            </div>
          </v-col>

          <v-col cols="3">
            <div class="text-subtitle-2">Tipo de Proveedor:</div>
            <div>{{ proveedor.nombre_proveedor_tipo }}</div>
          </v-col>

          <v-col cols="3">
            <div class="text-subtitle-2">Tipo de Persona:</div>
            <div>{{ proveedor.nombre_persona_tipo }}</div>
          </v-col>

          <v-col cols="3" v-if="proveedor.nombre_proveedor_nivel">
            <div class="text-subtitle-2">Nivel de Proveedor:</div>
            <div>{{ proveedor.nombre_proveedor_nivel }}</div>
          </v-col>

          <v-col cols="3" v-if="proveedor.nombre_proveedor_actividad">
            <div class="text-subtitle-2">Tipo de Proveedor Nacional:</div>
            <div>{{ proveedor.nombre_proveedor_actividad }}</div>
          </v-col>

          <v-col cols="6">
            <div class="text-subtitle-2">Nombre comercial:</div>
            <div>{{ proveedor.nombre_completo }}</div>
          </v-col>

          <v-col cols="6">
            <div class="text-subtitle-2">Nombre del Contacto:</div>
            <div>{{ proveedor.nombre_contacto }}</div>
          </v-col>

          <v-col cols="6">
            <div class="text-subtitle-2">Teléfono Empresarial/Sucursal:</div>
            <div>{{ proveedor.telefono }}</div>
          </v-col>

          <v-col cols="6">
            <div class="text-subtitle-2">Correo Electrónico:</div>
            <div>{{ proveedor.correo_electronico }}</div>
          </v-col>

          <v-col cols="3" v-if="proveedor.clave">
            <div class="text-subtitle-2">Clave:</div>
            <div>{{ proveedor.clave }}</div>
          </v-col>

          <!-- Datos Fiscales -->
          <v-col cols="12" class="pb-0 mb-0 text-center">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon>mdi-file-document</v-icon>
              Datos Fiscales
            </div>
          </v-col>

          <!-- Datos Fiscales Nacionales -->
          <template v-if="proveedor.id_proveedor_tipo == 'b1921daf-3922-47ad-8a80-33a0299babe5'">
            <v-col cols="4" v-if="proveedor.nombre_regimen_fiscal">
              <div class="text-subtitle-2">Régimen Fiscal:</div>
              <div>{{ proveedor.nombre_regimen_fiscal }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Nombre/Razón Social:</div>
              <div>{{ proveedor.razon_social }}</div>
            </v-col>

            <v-col cols="4" v-if="proveedor.rfc">
              <div class="text-subtitle-2">RFC:</div>
              <div>{{ proveedor.rfc }}</div>
            </v-col>

            <v-col cols="6">
              <div class="text-subtitle-2">Calle:</div>
              <div>{{ proveedor.calle }}</div>
            </v-col>

            <v-col cols="3">
              <div class="text-subtitle-2">Núm Exterior:</div>
              <div>{{ proveedor.num_ext }}</div>
            </v-col>

            <v-col cols="3" v-if="proveedor.num_int">
              <div class="text-subtitle-2">Núm Interior:</div>
              <div>{{ proveedor.num_int }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Estado:</div>
              <div>{{ proveedor.nombre_estado }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Municipio:</div>
              <div>{{ proveedor.nombre_municipio }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Código Postal:</div>
              <div>{{ proveedor.codigo_postal }}</div>
            </v-col>

            <v-col cols="6">
              <div class="text-subtitle-2">Localidad:</div>
              <div>{{ proveedor.localidad }}</div>
            </v-col>

            <v-col cols="6">
              <div class="text-subtitle-2">Colonia:</div>
              <div>{{ proveedor.colonia }}</div>
            </v-col>
          </template>

          <!-- Datos Fiscales Internacionales -->
          <template v-if="proveedor.id_proveedor_tipo == '733d857a-5692-40d7-b47c-dd0c70da0394'">
            <v-col cols="6">
              <div class="text-subtitle-2">Nombre/Razón Social:</div>
              <div>{{ proveedor.razon_social }}</div>
            </v-col>

            <v-col cols="6" v-if="proveedor.numero_fiscal">
              <div class="text-subtitle-2">Número de Identificación Fiscal:</div>
              <div>{{ proveedor.numero_fiscal }}</div>
            </v-col>

            <v-col cols="6">
              <div class="text-subtitle-2">Calle:</div>
              <div>{{ proveedor.calle }}</div>
            </v-col>

            <v-col cols="3">
              <div class="text-subtitle-2">Núm Exterior:</div>
              <div>{{ proveedor.num_ext }}</div>
            </v-col>

            <v-col cols="3" v-if="proveedor.num_int">
              <div class="text-subtitle-2">Núm Interior:</div>
              <div>{{ proveedor.num_int }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Código Postal:</div>
              <div>{{ proveedor.codigo_postal }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Ciudad:</div>
              <div>{{ proveedor.ciudad }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">Región/Estado/Provincia:</div>
              <div>{{ proveedor.region }}</div>
            </v-col>

            <v-col cols="4">
              <div class="text-subtitle-2">País:</div>
              <div>{{ proveedor.nombre_pais }}</div>
            </v-col>
          </template>

          <template v-if="proveedor.grupos != null && proveedor.grupos.length > 0">
            <v-expansion-panels
              multiple
            >
              <v-expansion-panel v-for="grupo in proveedor.grupos" :key="grupo.id_proveedor_requisito_grupo">
                <v-expansion-panel-header>
                <div class="d-flex align-center justify-center">
                  <v-icon left>
                    {{ getIconByGrupo(grupo.id_proveedor_requisito_grupo) }}
                  </v-icon>
                  <span class="font-weight-medium">{{ grupo.nombre }}</span>
                </div>
              </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <template v-for="requisito in grupo.requisitos">
                      <v-col
                        :key="`r-${requisito.id_proveedor_requisito}`"
                        :cols="requisito.tipo != 6 ? requisito.num_columnas : 6"
                        class="my-0 py-0"
                      >
                        <template v-if="requisito.documento == null">
                          <div :key="requisito.id_proveedor_requisito">
                            <div class="text-subtitle-2">{{ requisito.nombre }}:</div>
                            <div>Documento o Dato no Proporcionado</div>
                          </div>
                        </template>
                        <template v-else-if="requisito.tipo == 4">
                          <v-viewer
                            v-model="requisito.documento"
                            :label="requisito.nombre"
                            url-base="/api/Proveedores/DescargarProveedorDocumento"
                          />
                        </template>

                        <template v-else>
                          <div class="text-subtitle-2">{{ requisito.nombre }}:</div>
                          <v-row class="pa-0 ma-0">
                            <v-col cols="12" class="pa-0 ma-0 pl-2" style="align-self: center">
                              <template v-if="requisito.tipo == 2 || requisito.tipo == 7">
                                <div>{{ requisito.documento }}</div>
                              </template>
                              <template v-if="requisito.tipo == 3 || requisito.tipo == 8">
                                <v-autocomplete-text
                                  v-model="requisito.documento"
                                  :url-get="requisito.select_url"
                                  :item-value="requisito.select_value"
                                >
                                </v-autocomplete-text>
                              </template>

                              <template v-if="requisito.tipo == 5">
                                <v-btn
                                  @click="nuevaPestana(requisito.documento)"
                                  block
                                  color="primary"
                                  text
                                >
                                  Abrir Link de Google Maps
                                </v-btn>
                              </template>
                              <template v-if="requisito.tipo == 6">
                                <v-endpoint-text
                                  :url-get="`/Catalogos/MunicipioNombreCompleto/${requisito.documento}`"
                                >
                                </v-endpoint-text>
                              </template>
                            </v-col>
                          </v-row>
                        </template>
                      </v-col>
                    </template>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>

          <!-- Información de Bloqueo -->
          <template v-if="proveedor.bloqueado">
            <v-col cols="12" class="pb-0 mb-0 text-center">
              <div class="text-subtitle-1 font-weight-bold error--text">
                <v-icon color="error">mdi-lock</v-icon>
                Información de Bloqueo
              </div>
            </v-col>

            <v-col cols="3" v-if="proveedor.bloqueo_definitivo">
              <v-chip color="error" text-color="white" small>
                BLOQUEO DEFINITIVO
              </v-chip>
            </v-col>

            <v-col cols="3" v-if="proveedor.bloqueo_motivo">
              <div class="text-subtitle-2">Motivo del Bloqueo:</div>
              <div>{{ proveedor.bloqueo_motivo }}</div>
            </v-col>

            <v-col cols="3" v-if="proveedor.fecha_bloqueo">
              <div class="text-subtitle-2">Fecha de Bloqueo:</div>
              <div>{{ proveedor.fecha_bloqueo }}</div>
            </v-col>

            <v-col cols="3" v-if="proveedor.usuario_bloqueo">
              <div class="text-subtitle-2">Usuario que Bloqueó:</div>
              <div>{{ proveedor.usuario_bloqueo }}</div>
            </v-col>
          </template>

          <!-- Información de Auditoría -->
          <v-col cols="12" class="pb-0 mb-0 text-center">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon>mdi-history</v-icon>
              Información de Auditoría
            </div>
          </v-col>

          <v-col cols="6" v-if="proveedor.validado">
            <v-chip color="success" text-color="white" small class="mb-2">
              VALIDADO
            </v-chip>
            <div v-if="proveedor.usuario_valido">
              <div class="text-subtitle-2">Validado por:</div>
              <div>{{ proveedor.usuario_valido }}</div>
            </div>
            <div v-if="proveedor.fecha_valido" class="mt-2">
              <div class="text-subtitle-2">Fecha de Validación:</div>
              <div>{{ proveedor.fecha_valido }}</div>
            </div>
          </v-col>

          <v-col cols="6" v-if="proveedor.ultima_actualizacion">
            <div class="text-subtitle-2">Última Actualización:</div>
            <div>{{ proveedor.ultima_actualizacion }}</div>
            <div v-if="proveedor.usuario_actualizo" class="mt-2">
              <div class="text-subtitle-2">Actualizado por:</div>
              <div>{{ proveedor.usuario_actualizo }}</div>
            </div>
          </v-col>

          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="logs"
              dense
              :items-per-page="10"
              class="elevation-1"
            >
              <!-- Columna de icono/estado -->
              <template v-slot:[`item.icon`]="{ item }">
                <v-icon small :color="getColor(item.mensaje)">
                  {{ getIcon(item.mensaje) }}
                </v-icon>
              </template>

              <!-- Columna de fecha más compacta -->
              <template v-slot:[`item.fecha`]="{ item }">
                <span class="text-caption grey--text">{{ item.fecha }}</span>
              </template>

              <!-- Columna de usuario con chip -->
              <template v-slot:[`item.usuario`]="{ item }">
                <v-chip
                  x-small
                  label
                  :color="item.usuario.includes('Automatico') ? 'grey lighten-2' : 'blue lighten-4'"
                >
                  {{ item.usuario }}
                </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="close" :disabled="loading">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import VAutocompleteText from "@/components/VAutocompleteText.vue";
import VEndpointText from '@/components/VEndpointText.vue';
import VViewer from '@/components/VViewer.vue';

export default {
  name: 'ProveedorDetalleDialog',

  components: {
    VAutocompleteText,
    VEndpointText,
    VViewer
  },
  
  data() {
    return {
      dialog: false,
      loading: false,
      proveedor: {
        // Proveedor
        id_proveedor: null,
        id_proveedor_nivel: null,
        nombre_proveedor_nivel: '',
        id_proveedor_tipo: null,
        nombre_proveedor_tipo: '',
        id_persona_tipo: null,
        nombre_persona_tipo: '',
        rfc: '',
        id_proveedor_actividad: null,
        nombre_proveedor_actividad: '',
        clave: '',
        nombre_completo: '',
        nombre_contacto: '',
        telefono: '',
        correo_electronico: '',
        bloqueado: false,
        bloqueo_definitivo: false,
        bloqueo_motivo: '',
        fecha_bloqueo: '',
        usuario_bloqueo: '',
        // Proveedor Fiscal
        calle: '',
        num_ext: '',
        num_int: '',
        // Datos Fiscales Nacionales
        razon_social: '',
        id_estado: null,
        nombre_estado: '',
        id_municipio: null,
        nombre_municipio: '',
        id_regimen_fiscal: null,
        nombre_regimen_fiscal: '',
        codigo_postal: '',
        localidad: '',
        colonia: '',
        // Datos Fiscales Internacionales
        numero_fiscal: '',
        ciudad: '',
        region: '',
        id_pais: null,
        nombre_pais: '',

        // Usuarios
        ultima_actualizacion: '',
        usuario_actualizo: '',
        validado: false,
        usuario_valido: '',
        fecha_valido: ''
      },
      defaultProveedor: {
        // Proveedor
        id_proveedor: null,
        id_proveedor_nivel: null,
        nombre_proveedor_nivel: '',
        id_proveedor_tipo: null,
        nombre_proveedor_tipo: '',
        id_persona_tipo: null,
        nombre_persona_tipo: '',
        rfc: '',
        id_proveedor_actividad: null,
        nombre_proveedor_actividad: '',
        clave: '',
        nombre_completo: '',
        nombre_contacto: '',
        telefono: '',
        correo_electronico: '',
        bloqueado: false,
        bloqueo_definitivo: false,
        bloqueo_motivo: '',
        fecha_bloqueo: '',
        usuario_bloqueo: '',
        // Proveedor Fiscal
        calle: '',
        num_ext: '',
        num_int: '',
        // Datos Fiscales Nacionales
        razon_social: '',
        id_estado: null,
        nombre_estado: '',
        id_municipio: null,
        nombre_municipio: '',
        id_regimen_fiscal: null,
        nombre_regimen_fiscal: '',
        codigo_postal: '',
        localidad: '',
        colonia: '',
        // Datos Fiscales Internacionales
        numero_fiscal: '',
        ciudad: '',
        region: '',
        id_pais: null,
        nombre_pais: '',
        // Usuarios
        ultima_actualizacion: '',
        usuario_actualizo: '',
        validado: false,
        usuario_valido: '',
        fecha_valido: ''
      },
      logs: [],
      headers: [
        { text: '', value: 'icon', width: '50px', sortable: false },
        { text: 'Fecha', value: 'fecha', width: '140px' },
        { text: 'Usuario', value: 'usuario', width: '200px' },
        { text: 'Acción', value: 'mensaje' }
      ],
    };
  },

  methods: {
    async open(id_proveedor) {
      this.dialog = true;
      this.loading = true;
      this.proveedor = Object.assign({}, this.defaultProveedor);
      this.logs = [];

      try {
        // Ejecutar ambas peticiones en paralelo
        const [proveedorResponse, logsResponse] = await Promise.all([
          axios.get(`/Proveedores/DetallesProveedor/${id_proveedor}`),
          axios.get(`/Proveedores/ListarProveedorCambios/${id_proveedor}`)
        ]);

        // Asignar los datos
        this.proveedor = proveedorResponse.data;
        this.logs = logsResponse.data; // Asigna según necesites

      } catch (error) {
        console.error(error);
        //this.$refs.alert?.showAlert('Error al cargar los detalles del proveedor', 'error');
        //this.close();
      } finally {
        this.loading = false; // Se ejecuta cuando ambas terminen (o falle alguna)
      }
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.proveedor = Object.assign({}, this.defaultProveedor);
      this.logs = [];
    },
    nuevaPestana(url) {
      window.open(url, '_blank');
    },
    getIcon(mensaje) {
      if (mensaje.includes('Invalidó') || mensaje.includes('INVALIDATE')) return 'mdi-close-circle'
      if (mensaje.includes('Validó') || mensaje.includes('VALIDATE')) return 'mdi-check-circle'
      if (mensaje.includes('Registró')) return 'mdi-file-document-edit'
      if (mensaje.includes('Asignó')) return 'mdi-tag'
      if(mensaje.includes('Actualizó')) return 'mdi-pencil'
      return 'mdi-information'
    },
    getColor(mensaje) {
      if (mensaje.includes('Invalidó') || mensaje.includes('INVALIDATE')) return 'red'
      if (mensaje.includes('Validó') || mensaje.includes('VALIDATE')) return 'success'
      if (mensaje.includes('Registró')) return 'primary'
      if (mensaje.includes('Asignó')) return 'info'
      if(mensaje.includes('Actualizó')) return 'blue'
      return 'grey'
    },
    getIconByGrupo(guid) {
      switch(guid) {
        case '1cf60378-4c20-4bdf-a9fa-3376b28ef1b5':
          return 'mdi-map-marker-radius'
        case 'e97417de-8fca-4f12-9618-d743dbf2e7ea':
          return 'mdi-file-document-multiple'
        default:
          return 'mdi-folder-outline'
      }
    }
  }
};
</script>